import { render, staticRenderFns } from "./searchType.vue?vue&type=template&id=83845132&scoped=true&"
import script from "./searchType.vue?vue&type=script&lang=js&"
export * from "./searchType.vue?vue&type=script&lang=js&"
import style0 from "./searchType.vue?vue&type=style&index=0&id=83845132&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83845132",
  null
  
)

export default component.exports